import React from 'react';

export default function ContactAddress3() {
  return (
    <>
      <p>
        <i className="fas fa-home mr-3"></i>
        Famphy Clinic, 1 Floor, Om City Complex, Budigere,
        <br />
        Bengaluru- 560049, Karnataka
      </p>

      <p>
        <i className="fas fa-envelope mr-3"></i>
        hello@famphy.com
      </p>

      <p>
        <i className="fas fa-phone mr-3"></i>
        +91 91486 13614
      </p>

      <iframe
        title="Famphy Clinic Budigere Location on Google Maps"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d124373.64714370908!2d77.66274832620505!3d13.056253595065822!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae0f8d90ca03d1%3A0x56824badb07d5932!2sFamily%20Clinics%20-Unit%20of%20FamPhy!5e0!3m2!1sen!2sin!4v1791222811114!5m2!1sen!2sin"
        width="100%"
        height="300"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="strict-origin-when-cross-origin"
      />
    </>
  );
}